import { render, staticRenderFns } from "./CollaboratorInputTag.vue?vue&type=template&id=5b4808dc&scoped=true"
import script from "./CollaboratorInputTag.vue?vue&type=script&lang=js"
export * from "./CollaboratorInputTag.vue?vue&type=script&lang=js"
import style0 from "./CollaboratorInputTag.vue?vue&type=style&index=0&id=5b4808dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4808dc",
  null
  
)

export default component.exports